// removed by extract-text-webpack-plugin
module.exports = {"sankey_container":"sankey_container__34U0R","sankey":"sankey__1d4mf","legend_container":"legend_container__1OrDk","legend_row":"legend_row__MRm3c","legend_row_title":"legend_row_title__wB6em","legend_row_detail":"legend_row_detail__3_0nL","child2":"child2__1mbu5","child3":"child3__2k3L1","child4":"child4__2dkAl"};


//////////////////
// WEBPACK FOOTER
// ./components/sankeyChart/style.scss
// module id = Vq5U
// module chunks = 0 1